// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Yrzu","productName":"Table_productName__1LT-z"};